export default __webpack_public_path__ + "static/SR France - Safety Data Sheet - Burnt Sugar (Powder)-4c244454a0b223773eb6f583f9faee63.pdf";